module.exports = __webpack_public_path__ + "img/mi-cape-town-logo-icon.95e6c1b3.png";